import React, { useEffect, useMemo } from 'react';
import { Route } from 'react-router-dom';
import { useLocalStorage } from 'react-haiku';
// import Count from 'react-countdown';
import { useCollect } from 'hooks';
import DayJs from 'utils/Dayjs';

import Show from 'components/Show';
import Modal from 'components/Modal';
import Update from 'components/Update';
import { Title } from 'components/Misc/Typography';

import Me from 'containers/Me';
import Home from 'containers/Student/Home';
import Subjects from 'containers/Student/Subjects';
import Courses from 'containers/Student/Courses';
import Exams from 'containers/Student/Exams';
import Marks from 'containers/Student/Marks';
import Materials from 'containers/Student/Materials';
import Webinars from 'containers/Student/Webinars';
import Payments from 'containers/Student/Payments';
import Articles from 'containers/Shared/Articles';

import { useAppStore } from 'store/useAppStore';

const Student = () => {
	// Use app storre
	const [user, update] = useAppStore(state => [state.user, state.update]);

	// ? Temporary: Use local storage for modal
	const [storageModalAvatar, setStorageModalAvatar] = useLocalStorage('modal-avatar');
	
	const days = useMemo(() => DayJs().set('date', 24).set('month', 3).set('year', 2024).diff(DayJs(), 'day'), []);
	const [storageModalVPS, setStorageModalVPS] = useLocalStorage(`modal-vps-${days}`);

	// const days = useMemo(() => DayJs().set('date', 15).set('month', 11).set('year', 2023).endOf('day').diff(DayJs(), 'day'), []);
	// const [storageModalExams, setStorageModalExams] = useLocalStorage(`modal-exams-${days}`);

	// Store requested user
	const [[grades], collectGrades] = useCollect('grades');
	const [[data], collect] = useCollect(`/users/${user.id}`);

	// Store active flag
	// const isActiveInExams = useMemo(() =>
	// 	grades?.find(grade => (grade.number === 12 || grade.number === 11 || grade.number === 10) && grade.state === 'active')
	// , [grades]);

	// Store active 12th grade flag
	const isActiveIn12th = useMemo(() =>
		grades?.find(grade => grade.number === 12 && grade.state === 'active')
	, [grades]);

	// Collect grades on mount and on parameter change
	useEffect(() => {
		(async () => await collectGrades())();
	}, [collectGrades]);

	// Collect grades on mount and on parameter change
	useEffect(() => {
		(async () => await collect())();
	}, [collect]);

	// const renderer = ({ days, hours, minutes }) => {
	// 	if (days > 1) {
	// 		return <Title title={`${days} dienām!`} className="text-4xl" />;
	// 	} else if (days === 1) {
	// 		return <Title title={`${days} dienas!`} className="text-4xl" />;
	// 	} else if (hours > 1) {
	// 		return <Title title={`${hours} stundām!`} className="text-4xl" />;
	// 	} else if (hours === 1 && minutes > 1) {
	// 		return <Title title={`${hours} stundas un ${minutes} minūtēm!`} className="text-4xl" />;
	// 	} else if (hours === 1 && minutes === 1) {
	// 		return <Title title={`${hours} stundas un ${minutes} minūtes!`} className="text-4xl" />;
	// 	} else if (hours === 0 && minutes > 1) {
	// 		return <Title title={`${minutes} minūtēm!`} className="text-4xl" />;
	// 	} else if (hours === 0 && minutes === 1) {
	// 		return <Title title={`${minutes} minūtes!`} className="text-4xl" />;
	// 	}
	// };
	
	return (
		<div className="app__content">
			{/* App's version update notification */}
			<Show if={update}>
				<Update />
			</Show>

			<Route path="/" exact>
				<Home />
			</Route>

			<Route path="/articles">
				<Articles />
			</Route>

			<Route path="/me">
				<Me />
			</Route>

			<Route path="/subjects">
				<Subjects />
			</Route>

			<Route path="/courses">
				<Courses />
			</Route>

			<Route path="/webinars">
				<Webinars />
			</Route>

			<Route path="/exams">
				<Exams />
			</Route>

			<Route path="/marks">
				<Marks />
			</Route>

			<Route path="/materials">
				<Materials />
			</Route>

			<Route path="/payments">
				<Payments />
			</Route>

			{/* Temporary modal */}
			<Modal title="Paziņojums" visible={(data && !data?.avatar) && !storageModalAvatar} handleModal={() => setStorageModalAvatar(true)}>
				<div className="text-center py-10">
					<Title title="Pievieno profila foto TAGAD, citādi tiksi bloķēts!" className="text-xl" />
				</div>
			</Modal>

			{/* Temporary vps modal until 24.04.2024 */}
			<Modal title="Paziņojums" visible={days >= 0 && isActiveIn12th && !storageModalVPS} handleModal={() => setStorageModalVPS(true)}>
				<div className="text-center py-10 space-y-3">
					<Title title="Vai iesniedzi piekļuves darbus VPS?" className="text-xl" />
					<Title title="Lieliski, ja esi jau iesniedzis!" className="text-base" />
				</div>
			</Modal>

			{/* Implement counter */}
			{/* <Modal title="Paziņojums" visible={isActiveInExams && !storageModalExams} handleModal={() => setStorageModalExams(true)}>
				<div className="text-center py-10 space-y-10">
					<Title title="Pieteikšanās eksāmeniem beidzas pēc" className="text-xl" />
					<Count
						renderer={renderer}
						onComplete={() => setStorageModalExams(true)}
						date={DayJs().set('date', 15).set('month', 11).set('year', 2023).endOf('day').toISOString()}
					/>
					<Title title="Malacis, ja esi pieteicies!" className="text-xl" />
				</div>
			</Modal> */}
		</div>
	);
};

// Paziņojums 12. klasēm - katru dienu, kad slēdzas klāt - līdz 24. aprīlim.
// Vai iesniedzi piekļuves darbus VPS?
// Lieliski, ja esi jau iesniedzis!

export default Student;
